import React from 'react';
import styles from './style.css';


const Button = ({onClick, disabled, style, userStyle, content}) => {
    let btnProps = {
        className: `${style} ${userStyle} ${disabled ? styles.disabled : ''}`
    }
    if(!disabled){
        btnProps.onClick = onClick
    }
    return (
        <div {...btnProps}>
            {content}
        </div>
    )
}

const TextButtonTypes = {
    primary: {className: styles.primaryButton},
    secondary: {className: styles.textButton}
}

const TextButton = ({onClick, text='', type=TextButtonTypes.secondary, children=null, disabled=false, style='', textStyle=''}) => {
    return (
        <Button style={type.className}
                userStyle={style}
                onClick={onClick}
                disabled={disabled}
                content={
                    <div className={`${styles.text} ${textStyle}`}>
                        {text}
                        {children}
                    </div>
                }
        />
    );
}

const IconTypes = {
    add: {className: styles.add, iconName: 'add'},
    delete: {className: styles.delete, iconName: 'delete_sweep'},
    clear: {className: styles.clear, iconName: 'clear'},
    edit: {className: styles.edit, iconName: 'edit'},
    done: {className: styles.done, iconName: 'done'}
}

const Icon = ({type, onClick, disabled=false, style='', iconStyle=''}) => {
    return (
        <Button style={type.className}
                userStyle={style}
                onClick={onClick}
                disabled={disabled}
                content={
                    <i className={`material-icons ${iconStyle}`}>
                        {type.iconName}
                    </i>
                }
        />
    );
}

export {TextButton, TextButtonTypes, Icon, IconTypes};


// WEBPACK FOOTER //
// ./src/components/Buttons/index.js